export enum LocalStorageKeys {
  LastOttoSSOEmail = 'last_otto_sso_email',
}
